import type {
  ArchiveCourseUseCase,
  CreateCourseUseCase,
  GetCourseUseCase,
  ListCoursesPaginatedUseCase,
  PublishCourseUseCase,
  UpdateCourseUseCase,
  ListCourseDisciplinesUseCase,
} from '@/application/port/in/CourseUseCase';
import type {
  CreateCourseCommand,
  ListCoursesQuery,
  UpdateCourseCommand,
} from '@/application/port/in/dto/CourseCommand';
import type { CourseGateway } from '@/application/port/out/CourseGateway';
import type { Course } from '@/domain/model/Course';
import type { Discipline } from '@/domain/model/Discipline';
import type { Page } from '@/domain/model/Page';

export class ListCoursesPaginatedUseCaseImpl
  implements ListCoursesPaginatedUseCase
{
  constructor(private readonly gateway: CourseGateway) {}

  execute(query: ListCoursesQuery): Promise<Page<Course>> {
    return this.gateway.list(query);
  }
}

export class GetCourseUseCaseImpl implements GetCourseUseCase {
  constructor(private readonly gateway: CourseGateway) {}

  execute(id: string): Promise<Course> {
    if (!id) return Promise.reject(new Error('ID do curso é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class CreateCourseUseCaseImpl implements CreateCourseUseCase {
  constructor(private readonly gateway: CourseGateway) {}

  execute(command: CreateCourseCommand): Promise<Course> {
    return this.gateway.create(command);
  }
}

export class UpdateCourseUseCaseImpl implements UpdateCourseUseCase {
  constructor(private readonly gateway: CourseGateway) {}

  execute(id: string, command: UpdateCourseCommand): Promise<Course> {
    return this.gateway.update(id, command);
  }
}

export class PublishCourseUseCaseImpl implements PublishCourseUseCase {
  constructor(private readonly gateway: CourseGateway) {}

  execute(id: string): Promise<Course> {
    return this.gateway.publish(id);
  }
}

export class ArchiveCourseUseCaseImpl implements ArchiveCourseUseCase {
  constructor(private readonly gateway: CourseGateway) {}

  execute(id: string): Promise<void> {
    return this.gateway.archive(id);
  }
}

export class ListCourseDisciplinesUseCaseImpl implements ListCourseDisciplinesUseCase {
  constructor(private readonly gateway: CourseGateway) {}
  execute(courseId: string): Promise<Discipline[]> { return this.gateway.listDisciplines(courseId); }
}



export class ChooseCourseCurriculumUseCaseImpl {
  constructor(private readonly gateway: CourseGateway) {}
  execute(courseId: string, curriculumId: string): Promise<Course> { return this.gateway.chooseCurriculum(courseId, curriculumId); }
}
